import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { fallback, zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

const DEFAULT_SEARCH = {
  datasetId: null,
} as const

const SEARCH_SCHEMA = z.object({
  datasetId: fallback(z.number().nullable(), DEFAULT_SEARCH.datasetId).default(
    DEFAULT_SEARCH.datasetId,
  ),
})

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/data-assets',
)({
  validateSearch: zodValidator(SEARCH_SCHEMA),
  search: {
    middlewares: [stripSearchParams(DEFAULT_SEARCH)],
  },
  loader: () => ({ breadcrumbTitle: 'Data assets' }),
})
